import { App } from 'antd';
import { getIntl } from '@/locales/intl';
import type { AppLocale } from '@/locales/types';
import { useLocaleStore } from '@/stores/localeStore';

/** Keep the current UI and its language if a new catalog cannot be downloaded. */
export function useChangeLocale() {
  const { message } = App.useApp();
  const setLocale = useLocaleStore((state) => state.setLocale);
  return async (locale: AppLocale) => {
    try {
      await setLocale(locale);
    } catch {
      void message.error(getIntl().formatMessage({ id: 'app.locale.loadError' }));
    }
  };
}
